// store/admin/question-bank/store/_actionTypes.js

// Create single question
export const CREATE_QUESTION_REQUEST = 'CREATE_QUESTION_REQUEST';
export const CREATE_QUESTION_SUCCESS = 'CREATE_QUESTION_SUCCESS';
export const CREATE_QUESTION_FAILURE = 'CREATE_QUESTION_FAILURE';

// Bulk create questions
export const BULK_CREATE_QUESTIONS_REQUEST = 'BULK_CREATE_QUESTIONS_REQUEST';
export const BULK_CREATE_QUESTIONS_SUCCESS = 'BULK_CREATE_QUESTIONS_SUCCESS';
export const BULK_CREATE_QUESTIONS_FAILURE = 'BULK_CREATE_QUESTIONS_FAILURE';

// Get questions by course
export const GET_QUESTIONS_BY_COURSE_REQUEST = 'GET_QUESTIONS_BY_COURSE_REQUEST';
export const GET_QUESTIONS_BY_COURSE_SUCCESS = 'GET_QUESTIONS_BY_COURSE_SUCCESS';
export const GET_QUESTIONS_BY_COURSE_FAILURE = 'GET_QUESTIONS_BY_COURSE_FAILURE';

// Update question
export const UPDATE_QUESTION_REQUEST = 'UPDATE_QUESTION_REQUEST';
export const UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS';
export const UPDATE_QUESTION_FAILURE = 'UPDATE_QUESTION_FAILURE';

// Delete question
export const DELETE_QUESTION_REQUEST = 'DELETE_QUESTION_REQUEST';
export const DELETE_QUESTION_SUCCESS = 'DELETE_QUESTION_SUCCESS';
export const DELETE_QUESTION_FAILURE = 'DELETE_QUESTION_FAILURE';

// Bulk delete questions
export const BULK_DELETE_QUESTIONS_REQUEST = 'BULK_DELETE_QUESTIONS_REQUEST';
export const BULK_DELETE_QUESTIONS_SUCCESS = 'BULK_DELETE_QUESTIONS_SUCCESS';
export const BULK_DELETE_QUESTIONS_FAILURE = 'BULK_DELETE_QUESTIONS_FAILURE';

// Local state management
export const SET_SELECTED_COURSE = 'SET_SELECTED_COURSE_QUESTION_BANK';
export const SET_SELECTED_QUESTION = 'SET_SELECTED_QUESTION';
export const CLEAR_QUESTION_BANK_ERROR = 'CLEAR_QUESTION_BANK_ERROR';
export const CLEAR_QUESTION_BANK_SUCCESS = 'CLEAR_QUESTION_BANK_SUCCESS';
export const RESET_QUESTION_BANK = 'RESET_QUESTION_BANK';
